import { useMutation, useQueryClient } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';
import { bridge } from 'shared/src/utils';

export const useDeleteFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: likedFolderService.delete,
    throwOnError: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey.getInfiniteLikeFolders,
      });
    },
    onError: error => bridge.toast(error.message || '오류가 발생했어요'),
  });
};
